import React from 'react'

/**
 * Shared "no admin portal access" state. Used both by HomeView (when a blocked
 * user lands on Home) and by AdminPortalGate (when a gated route's component
 * mounts without the grant), so the two never drift. Shows the message plus a
 * Refresh button — a just-granted user can re-check without hunting for a
 * reload (reload re-fetches /me/ability).
 *
 * `title` / `message` override the copy for a finer per-page denial (e.g. a
 * surface the user can't open even though they can reach the portal).
 */
interface Props {
  title?: string
  message?: string
}

export function NoAdminAccess({
  title = 'No access',
  message = 'You don’t have access to the admin portal. Please contact your administrator to request access, then refresh.',
}: Props = {}): JSX.Element {
  return (
    <div style={{ textAlign: 'center' }}>
      <div
        style={{
          margin: '64px auto 0',
          maxWidth: 560,
          padding: '32px 28px',
          border: '1px solid #e5e7eb',
          background: '#ffffff',
          borderRadius: 8,
        }}
      >
        <h2 style={{ marginTop: 0 }}>{title}</h2>
        <p style={{ margin: '12px 0 24px', color: '#4b5563', lineHeight: 1.5 }}>
          {message}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 24px',
            border: 'none',
            borderRadius: 6,
            background: '#0f4c81',
            color: '#fff',
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Refresh
        </button>
      </div>
    </div>
  )
}
